import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["checkbox", "count", "action", "form", "trigger", "table"]
  static values = { minSelection: Number }

  connect() {
    this.update()
  }

  enable(event) {
    event?.preventDefault()
    this.setActive(true)
  }

  disable(event) {
    event?.preventDefault()
    this.checkboxTargets.forEach((box) => { box.checked = false })
    this.setActive(false)
    this.update()
  }

  setActive(active) {
    if (this.hasTableTarget) this.tableTarget.classList.toggle("is-selecting", active)
    this.formTarget.classList.toggle("is-hidden", !active)
    if (this.hasTriggerTarget) this.triggerTarget.hidden = active
  }

  get minSelection() {
    return this.minSelectionValue > 0 ? this.minSelectionValue : 2
  }

  update() {
    if (!this.hasCountTarget) return

    const count = this.selectedIds().length
    const min = this.minSelection
    this.countTarget.textContent = count
    this.actionTarget.disabled = count < min
    this.actionTarget.classList.toggle("is-disabled", count < min)
  }

  selectedIds() {
    return this.checkboxTargets
      .filter((box) => box.checked)
      .map((box) => box.value)
  }

  submit(event) {
    const selected = this.selectedIds()
    if (selected.length < this.minSelection) {
      event.preventDefault()
      return
    }

    this.formTarget
      .querySelectorAll('input[name="subscription_ids[]"]')
      .forEach((input) => input.remove())

    selected.forEach((id) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "subscription_ids[]"
      input.value = id
      this.formTarget.appendChild(input)
    })
  }
}
